const TailWindToggle: React.FC<{
  onclick: (newState:boolean) => void;
  isEnable: boolean;
  label: string;
}> = ({ onclick, isEnable, label }) => {
  return (
    <button
      onClick={() => onclick(!isEnable)}
      className="flex gap-[8px] items-center hover:opacity-70 transition-opacity"
    >
      <div className="w-[10px] shrink-0" />
      <div
        className={`relative w-[28px] h-[16px] rounded-full transition-colors shrink-0 ${
          isEnable ? "bg-[#334155]" : "bg-[#cbd5e1]"
        }`}
      >
        <div
          className={`absolute top-[2px] w-[12px] h-[12px] bg-white rounded-full transition-transform ${
            isEnable ? "translate-x-[14px]" : "translate-x-[2px]"
          }`}
        />
      </div>
      <p className="flex-1 font-['Inter',sans-serif] font-medium text-left text-[13px] md:text-[9px] text-[#334155] tracking-[-0.099px] leading-[1.5]">
        {label}
      </p>
    </button>
  );
};

export default TailWindToggle;